export const BASE_PATH = import.meta.env.VITE_BASE_PATH;
export const BREAKPOINT_XXS = '430px';
export const BREAKPOINT_XS = '768px';
export const BREAKPOINT_SM = '990px';
export const BREAKPOINT_MD = '1440px';
export const BREAKPOINT_L = '1728px';
